(() => {
  const roots = document.querySelectorAll('[data-pg-reviews]:not([data-pg-reviews-ready])');

  roots.forEach((root) => {
    root.dataset.pgReviewsReady = 'true';

    const providerSlot = root.querySelector('[data-pg-review-provider-slot]');
    const writeButton = root.querySelector('[data-pg-reviews-write]');
    const moreButton = root.querySelector('[data-pg-reviews-more]');
    const moreButtonLabel = moreButton && moreButton.querySelector('[data-pg-reviews-more-label]');
    const providerLabel = root.querySelector('[data-pg-provider-label]');
    const initialReviewLimit = 6;
    const reviewIncrement = Number(
      root.dataset.pgReviewIncrement || 0
    );
    let visibleReviewLimit = initialReviewLimit;
    const fallback = {
      rating: Number(root.dataset.fallbackRating || 0),
      count: Number(root.dataset.fallbackCount || 0),
      photos: Number(root.dataset.fallbackPhotos || 0),
      fiveStar: Number(root.dataset.fallbackFiveStar || 0)
    };

    const setText = (selector, value) => {
      root.querySelectorAll(selector).forEach((element) => {
        element.textContent = String(value);
      });
    };

    const applyStats = (stats) => {
      const rating = Number.isFinite(stats.rating) ? stats.rating : fallback.rating;
      const count = Number.isFinite(stats.count) ? stats.count : fallback.count;
      const photos = Number.isFinite(stats.photos) ? stats.photos : fallback.photos;
      const fiveStar = Number.isFinite(stats.fiveStar) ? stats.fiveStar : fallback.fiveStar;
      const ratingLabel = rating.toFixed(1);

      setText('[data-pg-rating]', ratingLabel);
      setText('[data-pg-review-count]', count);
      setText('[data-pg-photo-count]', photos);
      setText('[data-pg-five-star]', Math.round(fiveStar));

      root.querySelectorAll('[data-pg-stars]').forEach((element) => {
        element.setAttribute('aria-label', ratingLabel + ' out of 5 stars');
      });

      const histogram = Array.isArray(stats.histogram) ? stats.histogram : [];
      root.querySelectorAll('[data-pg-distribution-row]').forEach((row) => {
        const ratingValue = Number(row.dataset.pgDistributionRow);
        const match = histogram.find((item) => Number(item.rating) === ratingValue);
        let percent = match ? Number(match.percentage || 0) : 0;
        let frequency = match ? Number(match.frequency || 0) : 0;

        if (!histogram.length) {
          if (ratingValue === 5) percent = fiveStar;
          if (ratingValue === 4) percent = Math.max(0, 100 - fiveStar);
        }

        const fill = row.querySelector('[data-pg-distribution-fill]');
        const meta = row.querySelector('[data-pg-distribution-meta]');
        if (fill) fill.style.setProperty('--pg-review-percent', Math.max(0, Math.min(100, percent)) + '%');
        if (meta) meta.textContent = histogram.length ? frequency + ' · ' + Math.round(percent) + '%' : Math.round(percent) + '%';
      });
    };

    const readJudgeMe = () => {
      if (!providerSlot) return false;
      const dataScript = providerSlot.querySelector('script.jdgm-all-reviews-widget-v2025-data-json');
      if (!dataScript) return false;

      try {
        const data = JSON.parse(dataScript.textContent || '{}');
        const histogram = Array.isArray(data.histogram) ? data.histogram : [];
        const fiveStar = histogram.find((item) => Number(item.rating) === 5);
        applyStats({
          rating: Number(data.average_rating),
          count: Number(data.number_of_reviews),
          photos: Array.isArray(data.photo_gallery) ? data.photo_gallery.length : fallback.photos,
          fiveStar: fiveStar ? Number(fiveStar.percentage) : fallback.fiveStar,
          histogram
        });
        root.dataset.reviewProvider = 'judge-me';
        if (providerLabel) providerLabel.textContent = 'Judge.me';
        return true;
      } catch (error) {
        return false;
      }
    };

    const readKlaviyo = () => {
      if (!providerSlot) return false;
      const klaviyoRoot = providerSlot.querySelector("[class*='kl_reviews'], [data-klaviyo-reviews], [data-testid*='reviews-widget']");
      if (!klaviyoRoot) return false;

      const text = (klaviyoRoot.textContent || '').replace(/\s+/g, ' ');
      const ratingMatch = text.match(/([1-5](?:\.\d+)?)\s*(?:out of|\/)\s*5/i);
      const countMatch = text.match(/([\d,]+)\s+(?:customer\s+)?reviews?/i);

      applyStats({
        rating: ratingMatch ? Number(ratingMatch[1]) : fallback.rating,
        count: countMatch ? Number(countMatch[1].replace(/,/g, '')) : fallback.count,
        photos: fallback.photos,
        fiveStar: fallback.fiveStar,
        histogram: []
      });
      root.dataset.reviewProvider = 'klaviyo';
      if (providerLabel) providerLabel.textContent = 'Klaviyo Reviews';
      return true;
    };

    let fullReviewTimer = null;

    const syncReviewLimit = () => {
      if (!providerSlot || !moreButton) return;

      const items = Array.from(
        providerSlot.querySelectorAll(
          '.jdgm-masonry-grid__masonry-item'
        )
      );
      const incremental = reviewIncrement > 0;
      const expanded =
        !incremental &&
        moreButton.getAttribute('aria-expanded') === 'true';
      const displayLimit = expanded
        ? items.length
        : Math.max(initialReviewLimit, visibleReviewLimit);

      items.forEach((item, index) => {
        item.classList.toggle(
          'pg-reviews__review-hidden',
          index >= displayLimit
        );
      });

      const hasMore = items.length > displayLimit;
      moreButton.hidden = incremental
        ? root.dataset.pgReviewDisplay !== 'complete' || !hasMore
        : items.length <= initialReviewLimit;
      if (incremental) {
        moreButton.removeAttribute('aria-expanded');
      } else {
        moreButton.setAttribute(
          'aria-expanded',
          String(expanded)
        );
      }

      if (moreButtonLabel) {
        moreButtonLabel.textContent = incremental
          ? 'View more reviews'
          : expanded
            ? 'View fewer reviews'
            : 'View more reviews';
      }
    };

    const expectedJudgeMeReviewCount = () => {
      if (!providerSlot) return 0;
      const dataScript = providerSlot.querySelector('script.jdgm-all-reviews-widget-v2025-data-json');
      if (!dataScript) return 0;

      try {
        const data = JSON.parse(dataScript.textContent || '{}');
        return Number(data.number_of_reviews || 0);
      } catch (error) {
        return 0;
      }
    };


    const upgradeJudgeMeReviewImages = () => {
      if (!providerSlot) return;

      const withWidth = (source, width) => {
        if (!source || !source.includes('review-images.judgeme.com')) return source;
        if (/([?&])width=\d+/i.test(source)) {
          return source.replace(/([?&])width=\d+/i, '$1width=' + width);
        }
        return source + (source.includes('?') ? '&' : '?') + 'width=' + width;
      };

      providerSlot.querySelectorAll(".jdgm-review-card img[alt='Review Image']").forEach((image) => {
        const source = image.getAttribute('src') || '';
        const standardSource = withWidth(source, 480);
        const retinaSource = withWidth(source, 960);

        if (standardSource) image.setAttribute('src', standardSource);
        if (standardSource && retinaSource) {
          image.setAttribute('srcset', standardSource + ' 1x, ' + retinaSource + ' 2x');
        }
      });
    };

    const completeJudgeMeReviewFeed = () => {
      if (!providerSlot) return;

      upgradeJudgeMeReviewImages();

      providerSlot.querySelectorAll('.jdgm-review-card__more-text').forEach((label) => {
        label.setAttribute('aria-hidden', 'true');
      });

      const loadedCount = providerSlot.querySelectorAll('.jdgm-review-card').length;
      const expectedCount = expectedJudgeMeReviewCount();
      const loadButton = providerSlot.querySelector('.jdgm-masonry-grid__btn');

      if (expectedCount && loadedCount >= expectedCount) {
        root.dataset.pgReviewDisplay = 'complete';
        const footer = providerSlot.querySelector('.jdgm-masonry-grid__footer');
        if (footer) footer.setAttribute('aria-hidden', 'true');
        syncReviewLimit();
        return;
      }

      root.dataset.pgReviewDisplay = loadedCount ? 'loading' : 'waiting';
      syncReviewLimit();

      if (!loadButton || loadButton.dataset.pgAutoExpand === 'true') return;

      loadButton.dataset.pgAutoExpand = 'true';
      loadButton.click();

      window.setTimeout(() => {
        const updatedCount = providerSlot.querySelectorAll('.jdgm-review-card').length;

        if (updatedCount === loadedCount && loadButton.isConnected) {
          ['keydown', 'keyup'].forEach((type) => {
            loadButton.dispatchEvent(new KeyboardEvent(type, {
              key: 'Enter',
              code: 'Enter',
              keyCode: 13,
              which: 13,
              bubbles: true,
              cancelable: true
            }));
          });
        }

        window.setTimeout(() => {
          if (loadButton.isConnected) delete loadButton.dataset.pgAutoExpand;
          scheduleFullReviewFeed();
        }, 900);
      }, 900);
    };

    const scheduleFullReviewFeed = () => {
      window.clearTimeout(fullReviewTimer);
      fullReviewTimer = window.setTimeout(completeJudgeMeReviewFeed, 120);
    };

    const syncProvider = () => readJudgeMe() || readKlaviyo();

    applyStats({
      rating: fallback.rating,
      count: fallback.count,
      photos: fallback.photos,
      fiveStar: fallback.fiveStar,
      histogram: []
    });

    if (!syncProvider() && providerSlot) {
      const observer = new MutationObserver(() => {
        if (syncProvider()) observer.disconnect();
      });
      observer.observe(providerSlot, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    }

    if (providerSlot) {
      const fullReviewObserver = new MutationObserver(scheduleFullReviewFeed);
      fullReviewObserver.observe(providerSlot, { childList: true, subtree: true });
      scheduleFullReviewFeed();
    }

    if (moreButton) {
      moreButton.addEventListener('click', () => {
        if (reviewIncrement > 0) {
          if (root.dataset.pgReviewDisplay !== 'complete') return;
          visibleReviewLimit += reviewIncrement;
          syncReviewLimit();
          return;
        }

        const expanded =
          moreButton.getAttribute('aria-expanded') === 'true';
        moreButton.setAttribute(
          'aria-expanded',
          String(!expanded)
        );
        syncReviewLimit();
      });
    }

    if (writeButton) {
      writeButton.addEventListener('click', () => {
        const providerButton = providerSlot && providerSlot.querySelector(
          ".jm-action-buttons__button, [class*='kl_reviews'] button[class*='write'], [data-klaviyo-reviews] button[class*='write'], [data-testid*='write-review']"
        );

        if (providerButton) {
          providerButton.click();
        } else if (providerSlot) {
          providerSlot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
})();

(() => {
  const root = document.querySelector('[data-pg-reviews]');
  if (!root) return;

  const providerSlot = root.querySelector('[data-pg-review-provider-slot]');
  if (!providerSlot) return;

  const normaliseSource = (source) => (source || '').split('?')[0];

  const enhanceGalleries = () => {
    const dataScript = providerSlot.querySelector('script.jdgm-all-reviews-widget-v2025-data-json');
    if (!dataScript) return;

    let records;
    try {
      const data = JSON.parse(dataScript.textContent || '{}');
      records = [
        ...(Array.isArray(data.photo_gallery) ? data.photo_gallery : []),
        ...(Array.isArray(data.all_reviews) ? data.all_reviews : [])
      ];
    } catch (error) {
      return;
    }

    const reviewByImage = new Map();
    records.forEach((review) => {
      (Array.isArray(review.pictures_urls) ? review.pictures_urls : []).forEach((picture) => {
        [picture.original, picture.huge, picture.compact, picture.small].forEach((source) => {
          const key = normaliseSource(source);
          if (key) reviewByImage.set(key, review);
        });
      });
    });

    providerSlot.querySelectorAll('.jdgm-review-card').forEach((card) => {
      const gallery = card.querySelector('.jdgm-review-card__media-thumbnail');
      if (!gallery) return;

      const firstImage = gallery.querySelector("img[alt='Review Image']");
      const review = firstImage && reviewByImage.get(normaliseSource(firstImage.getAttribute('src')));
      const pictures = review && Array.isArray(review.pictures_urls) ? review.pictures_urls : [];

      card.querySelectorAll('.jdgm-review-card__media-frame-overlay').forEach((overlay) => overlay.remove());

      const existingSources = new Set(
        Array.from(gallery.querySelectorAll('img'))
          .map((image) => normaliseSource(image.getAttribute('src')))
          .filter(Boolean)
      );

      pictures.forEach((picture, index) => {
        const source = picture.original || picture.huge || picture.compact || picture.small;
        const key = normaliseSource(source);
        if (!source || existingSources.has(key)) return;

        const frame = document.createElement('a');
        frame.className = 'jm-frame jdgm-review-card__media-frame pg-reviews__media-frame--supplement';
        frame.href = source;
        frame.target = '_blank';
        frame.rel = 'noopener';
        frame.setAttribute('aria-label', 'View PegGrid customer review image ' + (index + 1));

        const image = document.createElement('img');
        image.src = source;
        image.alt = 'PegGrid customer review image ' + (index + 1);
        image.loading = 'lazy';
        frame.appendChild(image);
        gallery.appendChild(frame);
        existingSources.add(key);
      });

      const frames = Array.from(gallery.querySelectorAll('.jdgm-review-card__media-frame'));
      frames.forEach((frame, index) => {
        const extra = index >= 4;
        frame.hidden = extra;
        if (extra) frame.dataset.pgReviewImageExtra = 'true';
        else delete frame.dataset.pgReviewImageExtra;
      });

      const extraFrames = frames.filter((frame) => frame.dataset.pgReviewImageExtra === 'true');
      let button = card.querySelector('[data-pg-review-images-more]');

      if (!extraFrames.length) {
        if (button) button.remove();
        return;
      }

      if (!button) {
        button = document.createElement('button');
        button.className = 'pg-reviews__view-more-images';
        button.type = 'button';
        button.dataset.pgReviewImagesMore = 'true';
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = '<span data-pg-review-images-label>View more images</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"></path></svg>';
        const cover = card.querySelector('.jdgm-review-card__media-cover');
        if (cover) cover.insertAdjacentElement('afterend', button);
        else gallery.insertAdjacentElement('afterend', button);

        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          extraFrames.forEach((frame) => { frame.hidden = expanded; });
          const label = button.querySelector('[data-pg-review-images-label]');
          if (label) label.textContent = expanded ? 'View more images' : 'View fewer images';
        });
      }
    });
  };

  let timer;
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhanceGalleries, 120);
  };

  new MutationObserver(schedule).observe(providerSlot, { childList: true, subtree: true });
  schedule();
})();

/* PegGrid review row equaliser 2026-09-05 */
(() => {
  const roots = document.querySelectorAll('[data-pg-reviews]');

  roots.forEach((root) => {
    const providerSlot = root.querySelector('[data-pg-review-provider-slot]');
    if (!providerSlot) return;

    let alignmentTimer = null;

    const visibleReviewItems = () => Array.from(
      providerSlot.querySelectorAll('.jdgm-masonry-grid__masonry-item')
    ).filter((item) => (
      !item.classList.contains('pg-reviews__review-hidden') &&
      item.getClientRects().length > 0
    ));

    const alignRows = () => {
      const items = visibleReviewItems();
      const stacks = items
        .map((item) => item.querySelector('.jdgm-review-card__content > .jm-stack'))
        .filter(Boolean);

      stacks.forEach((stack) => {
        Array.from(stack.children).slice(0, 3).forEach((zone) => {
          zone.style.removeProperty('min-height');
        });
      });

      if (window.matchMedia('(max-width: 749px)').matches) return;

      const rows = [];

      items.forEach((item) => {
        const top = item.getBoundingClientRect().top;
        let row = rows.find((candidate) => Math.abs(candidate.top - top) <= 2);

        if (!row) {
          row = { top, items: [] };
          rows.push(row);
        }

        row.items.push(item);
      });

      rows.forEach((row) => {
        const rowStacks = row.items
          .map((item) => item.querySelector('.jdgm-review-card__content > .jm-stack'))
          .filter(Boolean);

        [0, 1, 2].forEach((zoneIndex) => {
          const zones = rowStacks
            .map((stack) => stack.children[zoneIndex])
            .filter(Boolean);

          const zoneHeight = Math.max(
            0,
            ...zones.map((zone) => Math.ceil(zone.getBoundingClientRect().height))
          );

          zones.forEach((zone) => {
            zone.style.setProperty('min-height', zoneHeight + 'px', 'important');
          });
        });
      });
    };

    const scheduleAlignment = () => {
      window.clearTimeout(alignmentTimer);
      alignmentTimer = window.setTimeout(() => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(alignRows);
        });
      }, 80);
    };

    new MutationObserver(scheduleAlignment).observe(providerSlot, {
      childList: true,
      subtree: true
    });

    root.querySelector('[data-pg-reviews-more]')?.addEventListener('click', scheduleAlignment);
    providerSlot.addEventListener('change', scheduleAlignment);
    window.addEventListener('resize', scheduleAlignment, { passive: true });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleAlignment);
    }

    scheduleAlignment();
  });
})();
